import { render } from "./AddToBag.vue?vue&type=template&id=760d8a12"
import script from "./AddToBag.vue?vue&type=script&lang=js"
export * from "./AddToBag.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__